import { Text } from "@fluentui/react-components";
import {
  BriefcaseRegular,
  CalendarDateRegular,
  CallRegular,
  MailRegular,
} from "@fluentui/react-icons";
import { formatDateString, getEmployeeFullName } from "library/utils";
import styled from "styled-components";

import { Flex } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
import useEmployee from "hooks/useEmployee";

type Props = {
  showName?: boolean;
};

export function EmployeeDetailsList({ showName }: Props) {
  const theme = useAppTheme();
  const { employeeData } = useEmployee();

  if (!employeeData) return null;

  const employeeFullName = getEmployeeFullName(employeeData);

  return (
    <Container>
      {showName ? (
        <Flex>
          <Text
            style={{
              fontSize: "22px",
            }}
            weight="medium"
          >
            {employeeFullName}
          </Text>
        </Flex>
      ) : (
        ""
      )}
      <Flex>
        <MailRegular
          style={{
            fontWeight: "bold",
            fontSize: "20px",
            color: theme.palette.purpleDark,
          }}
        />
        <TextStyled>{employeeData?.emailAddress}</TextStyled>
      </Flex>
      <Flex>
        <CallRegular
          style={{
            fontWeight: "bold",
            fontSize: "20px",
            color: theme.palette.purpleDark,
          }}
        />
        <TextStyled>{employeeData?.mobilePhoneNumber}</TextStyled>
      </Flex>

      {employeeData?.workplace && !showName ? (
        <Flex>
          <BriefcaseRegular
            style={{
              fontWeight: "bold",
              fontSize: "20px",
              color: theme.palette.purpleDark,
            }}
          />
          <TextStyled>{employeeData?.workplace}</TextStyled>
        </Flex>
      ) : null}
      <Flex>
        <CalendarDateRegular
          style={{
            fontWeight: "bold",
            fontSize: "20px",
            color: theme.palette.purpleDark,
          }}
        />
        <TextStyled>{formatDateString(employeeData?.dateOfEmployment || "")}</TextStyled>
      </Flex>
    </Container>
  );
}

const Container = styled.div`
  padding: 10px 20px 20px;
  position: relative;
  display: flex;
  justify-content: space-between;
  gap: 7px;
  flex-direction: column;
`;

const TextStyled = styled(Text)`
  font-weight: 400;
  font-size: 14px;
`;
